import { Box, Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import withStyles from "@material-ui/core/styles/withStyles"
import DeleteIcon from "@material-ui/icons/Delete"
import moment from "moment-timezone"
import React from "react"
import { useDispatch } from "react-redux"
import { deleteDeviceData } from "../../actions/dataClearingActions"
import { fetchDevice } from "../../actions/deviceActions"
import { Page } from "../../util/constants"
import { getDeviceVoltageElement } from "../../util/deviceHelpers"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import BasicModal from "../Common/Modals/BasicModal"

const styles = () => ({
  button: {
    margin: "0px 5px",
  },
  text: {
    margin: 0,
  },
  warning: {
    margin: 0,
    color: "#f44336",
  },
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    padding: 8,
    flexDirection: "column",
  },
  insightContainer: {
    padding: "10px 0",
    margin: 0,
  },
  insightTitle: {
    marginBottom: "5px",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
})

const DeviceView = (props) => {
  const {
    classes,
    deviceId,
    insightCount,
    latitude,
    longitude,
    deviceName,
    mostRecentClassName,
    mostRecentTimestamp,
    setTab,
    location,
    lastSeen,
    insightWarning,
    spypointCableError,
    syncWarning,
    batteryLevelWarning,
    filterManager,
    _lastOnDeviceTimestamp,
    device_battery,
  } = props
  const dispatch = useDispatch()
  const count = insightCount ? insightCount : 0
  const hasRecent = mostRecentClassName && mostRecentTimestamp

  const handleDelete = async () => {
    await deleteDeviceData(deviceId, { location: true })
    dispatch(fetchDevice())
  }

  const handleSeeInsightsClick = () => {
    filterManager.clearSavedFilters()
    filterManager.getFilter(FILTER_TYPE.DEVICE.ID).value = deviceId
    filterManager.saveFilters()
    setTab([Page.USER_INSIGHTS])
  }

  return (
    <div className={classes.container}>
      <Box style={{ marginBottom: 10 }} display="flex" alignItems="center" gap={1.5}>
        <h1 style={{ margin: 0 }}>{deviceName}</h1>

        {getDeviceVoltageElement(device_battery).element}
      </Box>
      <p className={classes.text}>
        <b>Device ID: </b> {deviceId}
      </p>
      {!!location && (
        <p className={classes.text}>
          <b>Location: </b> {location}
        </p>
      )}
      {!!latitude && !!longitude && (
        <p className={classes.text}>
          <b>Lat/Long: </b> {`${latitude}, ${longitude}`}
        </p>
      )}
      {!!lastSeen && (
        <p className={classes.text}>
          <b>Last Seen (UTC): </b> {`${moment(lastSeen).tz("UTC").format("MMM Do YYYY, h:mm a")}`}
        </p>
      )}
      {/* {!!lastOnDeviceTimestamp && (
        <p className={classes.text}>
          <b>Last On-Device Timestamp: </b>{" "}
          {`${moment(lastOnDeviceTimestamp).tz("UTC").format("MMM Do YYYY, h:mm a")}`}
        </p>
      )} */}
      {!!insightWarning &&
        Math.floor((Date.now() - new Date(lastSeen).valueOf()) / (1000 * 60 * 60 * 24)) >= 7 && (
          <p className={classes.warning}>
            <b>Last Check In: </b>{" "}
            {Math.floor((Date.now() - new Date(lastSeen).valueOf()) / (1000 * 60 * 60 * 24))} days
            ago
          </p>
        )}
      {!!spypointCableError && (
        <p className={classes.warning}>
          <b>Spypoint Cable Error</b>
        </p>
      )}
      {!!syncWarning && (
        <p className={classes.warning}>
          <b>No Recent Camera Triggers</b>
        </p>
      )}
      {!!batteryLevelWarning && (
        <p className={classes.warning}>
          <b>Battery Levels Low</b>
        </p>
      )}
      <p className={classes.text}>
        <b>Insight Count: </b> {count}
      </p>

      {hasRecent && (
        <div className={classes.insightContainer}>
          <h3 className={classes.insightTitle}>Most Recent Insight</h3>
          <p className={classes.text}>
            <b>Class Name: </b> {mostRecentClassName}
          </p>
          <p className={classes.text}>
            <b>Timestamp (UTC): </b>
            {moment(mostRecentTimestamp).tz("UTC").format("MMM Do YYYY, h:mm a")}{" "}
          </p>
        </div>
      )}

      <div className={classes.buttonContainer}>
        {count > 0 && (
          <Button
            className={classes.button}
            variant="contained"
            onClick={handleSeeInsightsClick}
            color="primary"
          >
            See All Insights
          </Button>
        )}
        <BasicModal
          confirmText="Delete"
          title={`Remove Device from Map?`}
          content={
            <Typography>
              Remove this device from the map? If the device reports it's location in the future, it
              will reappear on the map at that location.
            </Typography>
          }
          icon={<DeleteIcon />}
          fullWidth
          confirmAction={handleDelete}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(DeviceView)
